import React, { lazy } from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['Your child cannot sit still for more than 5 minutes without grabbing a device', 'Homework time turns into a daily emotional war zone', 'Your child starts activities with excitement and quits before finishing', 'You feel guilty every time you hand over the iPad just to get some peace', 'Your child gets frustrated instantly when something feels too hard', 'You have tried everything and nothing seems to stick longer than a week', 'You worry your child is falling behind because they cannot concentrate at school', 'You spend your evenings searching Pinterest for activity ideas that never happen'];
  return <section className="bg-lightgray py-16 px-4 border-t border-border" data-id="element-112">
      <div className="max-w-4xl mx-auto" data-id="element-113">
        <div className="text-center mb-12" data-id="element-114">
          <h2 className="text-3xl md:text-5xl font-heading font-black text-navy mb-6 leading-tight" data-id="element-115">
            How many more evenings are you going to watch your child lose
            another hour to a screen — and feel completely powerless?
          </h2>
          <p className="text-lg md:text-xl text-muted mb-4 font-medium" data-id="element-116">
            You are a parent who cares. You research. You try. You want the best
            for your child.
          </p>
          <p className="text-base md:text-lg text-ink/80 mb-6 font-medium" data-id="element-117">
            But nobody told you that in a world designed to hijack your child's
            attention — willpower alone is not enough. Your child is not lazy.
            Your child is not broken. Your child simply never received the right
            brain training to build focus from the inside out.
          </p>
          <p className="text-lg md:text-xl font-bold text-orange" data-id="element-118">
            The problem was never your effort. The problem is that you were
            never given the right system.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-border shadow-sm" data-id="element-119">
          <h3 className="text-2xl font-heading font-bold text-navy mb-8 flex items-center" data-id="element-120">
            <XCircle className="w-8 h-8 text-softred mr-3" data-id="element-121" />
            Does any of this sound familiar?
          </h3>

          <ul className="space-y-5" data-id="element-122">
            {points.map((point, i) => <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} key={i} className="flex items-start" data-id="element-123">
                <span className="text-softred mr-4 text-xl mt-0.5" data-id="element-124">❌</span>
                <span className="text-base md:text-lg text-ink font-medium" data-id="element-125">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <div className="text-center mt-12" data-id="element-126">
          <p className="text-2xl md:text-3xl font-heading font-bold text-navy italic" data-id="element-127">
            What if this was the last week you felt this way?
          </p>
        </div>
      </div>
    </section>;
}